import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7922D8",
      light: "#F3EBFF",
    },
    text: {
      white: "#ffffff",
      black: "#000000",
      coralRed: "#F74D4D",
      gunmetal: "#777f97",
      aliceBlue: "#F4F7FA",
      orangeRed: "#EA580C",
      raisinBlack: "#161c2d",
      redicalRed: "#F64B4B",
      coolGrey: "#8692A6",
      lightGrey: "#f4f7fa",
      seaGreen: "#68D585",
      slateGray: "#343A40",
      lightGrey: "#F1F1F1",
      mediumGray: "#979797",
      darkBlue: "#04042C",
      flashWhite: "#F4F7FA",
      vividMalachite: "#08AD36",
      cobaltBlue: "#0C4AEA",
      gainsboro: "#D6D6D7",
      errorRed: "#d32f2f",
      borderGrey: "#dadada",
      chinesePurple: "#6a0dad",
    },
    gradient: {
      background:
        "linear-gradient(225.17deg, #7B11F9 0.3%, #7922D8 39.59%, #3636B2 100%)",
      footer: "linear-gradient(225deg, #313C59 0%, #161C2D 100%)",
    },
  },

  typography: {
    color: "#000000",
    fontFamily: "Roboto",

    heading_pr: {
      fontFamily: "Roboto",
      fontWeight: 600,
      lineHeight: 1.5,
      color: "#000000",
      fontSize: "2.5rem",
      // Responsive font sizes using breakpoints
      "@media (max-width:960px)": {
        fontSize: "2.25rem",
      },
      "@media (max-width:600px)": {
        fontSize: "2rem",
      },
      "@media (max-width:0px)": {
        fontSize: "2rem",
      },
    },

    heading_sec: {
      fontFamily: "Roboto",
      fontSize: "1rem",
      fontWeight: 400,
      color: "#777f97",
      lineHeight: "normal",
    },

    heading_services: {
      fontFamily: "Roboto",
      fontWeight: 600,
      lineHeight: 1.5,
      color: "#343A40",
      fontSize: "2.5rem",
      // Responsive font sizes using breakpoints
      "@media (max-width:960px)": {
        fontSize: "2.25rem",
      },
      "@media (max-width:600px)": {
        fontSize: "2rem",
      },
      "@media (max-width:0px)": {
        fontSize: "1.75rem",
      },
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "0px",
        },
      },
    },
  },
});

export default theme;
